import * as React from 'react';

export const ZenIcon = ({ className = "", style = {} }: { className?: string; style?: React.CSSProperties }) => {
  return (
    <svg 
      className={className}
      style={style}
      id="Layer_1" 
      enableBackground="new 0 0 512 512" 
      height="512" 
      viewBox="0 0 512 512" 
      width="512" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path 
          fill="#204A22"
          d="m425.761 346.792c-8.725-7.628-19.443-14.838-32.006-21.567-25.332 14.327-57.957 21.561-97.495 21.561-47.472 0-101.647-10.424-144.919-27.884-13.609-5.491-25.834-11.538-36.587-18.084-46.445 24.308-55.401 66.977-55.401 96.188 0 42.947 19.324 114.994 148.744 114.994 86.983 0 145.567-8.232 184.369-25.908 20.59-9.38 35.501-21.338 45.584-36.559 9.686-14.62 14.597-32.292 14.597-52.526 0-17.722-9.046-34.617-26.886-50.215z"
        />
        <path 
          fill="#204A22"
          d="m162.566 291.081c39.891 16.096 89.87 25.705 133.694 25.705 110.854 0 127.406-62.052 127.406-99.04 0-25.143-7.661-61.862-47.38-82.804-10.412 8.198-23.94 16.056-41.426 23.111-32.052 12.932-72.162 20.653-107.294 20.653-36.124 0-65.196-8.217-86.566-24.411-11.549 6.028-21.345 12.533-29.252 19.446-15.537 13.584-23.415 28.39-23.415 44.005s7.878 30.42 23.415 44.005c12.44 10.875 29.538 20.744 50.818 29.33z"
        />
        <path 
          fill="#204A22"
          d="m155.724 127.661c16.125 13.964 40.297 21.045 71.842 21.045 31.486 0 67.4-6.906 96.069-18.474 36.102-14.566 55.184-33.889 55.184-55.879s-19.082-41.313-55.184-55.879c-28.669-11.568-64.582-18.474-96.069-18.474-31.545 0-55.717 7.081-71.842 21.045-14.748 12.771-22.543 31.205-22.543 53.308s7.795 40.537 22.543 53.308z"
        />
      </g>
    </svg>
  );
};
